// Текст второй (необязательной) галочки — согласие на спец-категории (Часть 2 документа).
export function SpecialConsentNotice() {
  return (
    <span>
      Согласен на обработку{' '}
      <a href="/legal/consent.html#chast-2" target="_blank" rel="noopener" className="text-primary-600 underline">
        данных о здоровье (аллергии) и диете
      </a>{' '}
      — для персональных рекомендаций
    </span>
  );
}
